import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'

interface C202DeviceAddProps {
  execDeviceAdd: (
    rhq: string,
    sales_company: string,
    login_id: string,
    password: string,
    api_key: string,
    serial: string,
  ) => Promise<Result>
  loading: loadStatus
}
// C202 デバイス登録API呼出
export const useC202DeviceAdd = (): C202DeviceAddProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execDeviceAdd = async (
    rhq: string,
    sales_company: string,
    login_id: string,
    password: string,
    api_key: string,
    serial: string,
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      const body = {
        rhq: rhq,
        sales_company: sales_company,
        login_id: login_id,
        password: password,
        api_key: api_key,
        serial_number: serial,
      }

      const response = await axios.post(`${baseUrl}${stage}${apiUrl.devicesPath}`, body, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceAdd, loading }
}
